import {updateField} from "vuex-map-fields"
import {getDefaultState} from "./incidenceTypeState"

export default {
	updateField,
	RESET_STATE(state) {
		Object.assign(state, getDefaultState())
	},
	SET_INCIDENCE_TYPES(state, payload) {
		state.incidence_types = payload
	},
	SET_INCIDENCE_TYPE(state, payload) {
		state.incidence_type = payload
	},
	SET_VALIDATION_ERRORS(state, payload) {
		for (const key in payload) {
			state.validation_incidence_type[key] = '* '+payload[key][0]
		}
	},
	CLEAR_VALIDATION(state) {
		for (const key in state.validation_incidence_type) {
			state.validation_incidence_type[key] = null
		}
	},
}
